import { Directive, ElementRef, OnDestroy, OnInit, Optional } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SecurityService } from '../../service';
import { RdaAutenticado } from '../model';

@Directive({
  selector: '[appResponsavelPreenchimento]'
})
export class ResponsavelPreenchimentoDirective implements OnInit, OnDestroy {

  private initialStatusDisplay: string;
  private statusChanges: Subscription;

  constructor(
    private readonly element: ElementRef,
    private readonly securityService: SecurityService,
    @Optional() private readonly controlContainer: FormGroupDirective) {
  }

  private static isResponsavelPreenchimento(rda: RdaAutenticado) {
    const responsavel = rda.composicaoRdaResponsavelPreenchimento;
    const autenticado = rda.composicaoRda;
    return responsavel !== undefined && autenticado !== undefined && autenticado.id === responsavel.id;
  }

  ngOnInit(): void {
    this.initializeDefaultState();
  }

  private initializeDefaultState() {
    if (this.hasFormGroup()) {
      const formGroup = this.getFormGroup();
      this.checkAuthenticatedRDA(formGroup);
      this.formStatusChangeHandle();
    } else {
      this.initialStatusDisplay = this.element.nativeElement.style.display;
      this.element.nativeElement.style.display = 'none';
      this.evaluatePermissionDisplayElement();
    }
  }

  private formStatusChangeHandle() {
    this.statusChanges = this.getFormGroup().statusChanges.subscribe(() => {
      this.checkAuthenticatedRDA(this.getFormGroup());
    });
  }

  private checkAuthenticatedRDA(formGroup: FormGroup) {
    this.securityService.obterRdaAutenticado().subscribe(rda => {
      if (rda && !ResponsavelPreenchimentoDirective.isResponsavelPreenchimento(rda)) {
        formGroup.disable({emitEvent: false});
      }
    });
  }

  private evaluatePermissionDisplayElement() {
    this.securityService.obterRdaAutenticado().subscribe(rda => {
      if (!rda || ResponsavelPreenchimentoDirective.isResponsavelPreenchimento(rda)) {
        this.element.nativeElement.style.display = this.initialStatusDisplay;
      }
    });
  }

  private hasFormGroup() {
    return !!this.controlContainer
      && (this.element.nativeElement.tagName === 'MAT-CARD'
        || this.element.nativeElement.tagName === 'FORM'
        || this.element.nativeElement.tagName === 'MAT-LIST');
  }

  private getFormGroup() {
    return this.controlContainer ? this.controlContainer.control : undefined;
  }

  ngOnDestroy() {
    if (this.statusChanges) {
      this.statusChanges.unsubscribe();
    }
  }
}
